import type { WorkspaceTone } from '../model/workspaceCatalog'

export const workspaceToneClasses: Record<WorkspaceTone, { icon: string; card: string }> = {
  blue: { icon: 'bg-blue-50 text-blue-700', card: 'border-blue-100 bg-blue-50 text-blue-700' },
  orange: { icon: 'bg-orange-50 text-orange-700', card: 'border-orange-100 bg-orange-50 text-orange-700' },
  violet: { icon: 'bg-violet-50 text-violet-700', card: 'border-violet-100 bg-violet-50 text-violet-700' },
  emerald: { icon: 'bg-emerald-50 text-emerald-700', card: 'border-emerald-100 bg-emerald-50 text-emerald-700' },
  rose: { icon: 'bg-rose-50 text-rose-700', card: 'border-rose-100 bg-rose-50 text-rose-700' },
  amber: { icon: 'bg-amber-50 text-amber-700', card: 'border-amber-100 bg-amber-50 text-amber-700' },
}
